const angular = require('angular');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars

const olyCommonModule = require('../olycommon/olycommon.module');
const wowCommonModule = require('../common/common.module');
const analyticsModule = require('../analytics/analytics.module');

const InspirationService = require('./inspiration.service');
const { inspirationNavigationComponentDefinition } = require('./navigation/inspiration-navigation.component');
const { inspirationTileComponentDefinition } = require('./tile/inspiration-tile.component');
const { inspirationDetailTileComponentDefinition } = require('./tile/inspiration-detail-tile.component');
const { inspirationDetailTileListComponentDefinition } = require('./tile/inspiration-detail-tile-list.component');
const { inspirationDetailComponentDefinition } = require('./detail/inspiration-detail.component');

const inspirationModuleName = 'wowApp.inspiration';

angular.module(inspirationModuleName, [analyticsModule, olyCommonModule, wowCommonModule, uiRouter, 'restangular'])
    .service('InspirationService', ['Restangular', '$rootScope', '$window', 'LocalStorageWrapper', InspirationService])
    .component('wowInspirationNavigation', inspirationNavigationComponentDefinition)
    .component('wowInspirationTile', inspirationTileComponentDefinition)
    .component('wowInspirationDetailTile', inspirationDetailTileComponentDefinition)
    .component('wowInspirationDetailTileList', inspirationDetailTileListComponentDefinition)
    .component('wowInspirationDetail', inspirationDetailComponentDefinition);

module.exports = inspirationModuleName;



// WEBPACK FOOTER //
// ./src/inspiration/inspiration.module.js